import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import SPPositionFormGroup from "./SPPositionFormGroup";
import SearchField from "../SearchField/SearchField";
import useSPPosition from "../../hooks/useSPPosition";
import { handleFigureChange, handleFigureBlur, handleInputSelect, addEdits } from "./utils/inputhandlers";
import useSPUndo from "../../hooks/useSPUndo";
import useGlobalParams from "../../hooks/useGlobalParams";

const PositionsSPFigures = ({
  ignoreEnter,
  setShowcalculator,
  showcalculator,
  resetOutbound,
  resetOceanfreight,
  resetCustoms,
  resetInbound,
  clearfield,
}) => {
  // Load context values
  const { SPposition, setSPposition, setSPpositionData } = useSPPosition();
  const { positionEditsSP, editIDSP, setEditIDSP, editingFieldSP, setEditingFieldSP, undoListSP, inputRefsSP } =
    useSPUndo();
  const { globalparams } = useGlobalParams();

  // Local handleFigureChange and handleFigureBlur functions to allow shorthand in input component.
  const localHandleFigureChange = (e, type, dec = 2) => {
    handleFigureChange(e, type, setSPposition, setSPpositionData, setEditingFieldSP, dec);
  };
  const localHandleFigureBlur = (e, type, dec = 2) => {
    handleFigureBlur(
      e,
      type,
      setSPposition,
      positionEditsSP,
      editIDSP,
      setEditIDSP,
      editingFieldSP,
      setEditingFieldSP,
      undoListSP,
      dec
    );
  };
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      positionEditsSP,
      editIDSP,
      setEditIDSP,
      setSPposition,
      setSPpositionData,
      addEdits,
      undoListSP,
      origin,
      destination,
      globalparams
    );
  };
  return (
    <>
      <fieldset style={{ height: "90px" }}>
        <legend>Figures:</legend>
        <div className='form-group'>
          <label>Quantity (mt):</label>
          <div className='SPqtyandtolerance'>
            <input
              required
              type='text'
              name='quantity'
              value={SPposition?.quantity || ""}
              onKeyDown={ignoreEnter}
              onFocus={(e) => e.target.select()}
              onChange={(e) => localHandleFigureChange(e, "decimal")}
              onBlur={(e) => localHandleFigureBlur(e, "decimal")}
              ref={(el) => (inputRefsSP.current["quantity"] = el)}
            />
            <p>+/-</p>
            <input
              required
              style={{ minWidth: "35px", maxWidth: "45px" }}
              value={SPposition?.tolerance || ""}
              onFocus={(e) => e.target.select()}
              onChange={(e) => localHandleFigureChange(e, "percent", 2)}
              onBlur={(e) => localHandleFigureBlur(e, "percent", 2)}
              onKeyDown={ignoreEnter}
              name='tolerance'
              placeholder='% ...'
              ref={(el) => (inputRefsSP.current["tolerance"] = el)}
            />
          </div>
        </div>
        <SPPositionFormGroup labelname={"# Pallets"} inputname={"numpallets"} inputtype={"decimal"} />
      </fieldset>
      <fieldset>
        <legend>Costs (per mt):</legend>
        <SPPositionFormGroup labelname={"Material Cost"} inputname={"materialcost"} inputtype={"currency"} />
        <SPPositionFormGroup labelname={"P Commission"} inputname={"pcomission"} inputtype={"currency"} />
        <SPPositionFormGroup labelname={"P Finance Cost"} inputname={"pfinancecost"} inputtype={"currency"} />
        <div className='form-group'>
          <label>
            Outbound Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("outboundcost");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='outboundcost'
            value={SPposition?.outboundcost || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "outboundcost" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPPositionFormGroup labelname={"Payload (mt/FCL)"} inputname={"outpayload"} inputtype={"decimal"} />
            <SPPositionFormGroup labelname={"Drayage per FCL"} inputname={"outdrayage"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"Loading Fee per FCL"} inputname={"loading"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"Collect Charges"} inputname={"outcollectcharges"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"Outbound others"} inputname={"outboundothers"} inputtype={"currency"} />
            <SPPositionFormGroup readOnly={true} labelname={"Total Outbound"} inputname={"totaloutbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetOutbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <div className='form-group'>
          <label>
            Ocean Freight:
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("oceanfreight");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='freightpmt'
            value={SPposition?.freightpmt || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "oceanfreight" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPPositionFormGroup labelname={"Payload (mt)"} inputname={"oceanpayload"} inputtype={"decimal"} />
            <SPPositionFormGroup labelname={"Total Freight"} inputname={"oceanfreight"} inputtype={"currency"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                resetOceanfreight();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <div className='form-group'>
          <label>
            Import Customs Fee:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("importcustomsfee");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='importcustomsfee'
            value={SPposition?.importcustomsfee || ""}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "importcustomsfee" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPPositionFormGroup labelname={"Quantity"} inputname={"quantity"} inputtype={"decimal"} />
            <SPPositionFormGroup labelname={"Material Cost/mt"} inputname={"materialcost"} inputtype={"currency"} />
            <SPPositionFormGroup readOnly={true} labelname={"Material Value"} inputname={"materialvalue"} />
            <SPPositionFormGroup labelname={"General Duty(%)"} inputname={"generaldutyimp"} inputtype={"percent"} />
            <SPPositionFormGroup
              labelname={"Additional Duty(%)"}
              inputname={"additionaldutyimp"}
              inputtype={"percent"}
            />
            <SPPositionFormGroup readOnly={true} labelname={"Total Duty(%)"} inputname={"totalduty"} />
            <SPPositionFormGroup readOnly={true} labelname={"Duty Fee"} inputname={"dutyfee"} />
            <SPPositionFormGroup labelname={"Harbor Fee(%)"} inputname={"harborfeepct"} inputtype={"percent"} />
            <SPPositionFormGroup readOnly={true} labelname={"Harbor Fee"} inputname={"harborfee"} />
            <SPPositionFormGroup
              labelname={"Merch. Proc. Fee(%)"}
              inputname={"merchprocfeepct"}
              inputtype={"percent"}
            />
            <SPPositionFormGroup readOnly={true} labelname={"Merch. Proc. Fee"} inputname={"merchprocfee"} />
            <SPPositionFormGroup labelname={"Flat fee"} inputname={"flatfee"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"TSCA"} inputname={"tsca"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"ISF"} inputname={"isf"} inputtype={"currency"} />
            <SPPositionFormGroup readOnly={true} labelname={"Total Entry Fee"} inputname={"totalcentryfee"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetCustoms();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <div className='form-group'>
          <label>
            Inbound Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("inboundcost");
              }}
            />
          </label>
          <input
            readOnly
            required
            type='text'
            name='inboundcost'
            value={SPposition?.inboundcost}
            onKeyDown={ignoreEnter}
            onFocus={(e) => e.target.select()}
          />
        </div>
        {showcalculator === "inboundcost" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <SPPositionFormGroup labelname={"Payload (mt/FCL)"} inputname={"inpayload"} inputtype={"decimal"} />
            <SPPositionFormGroup labelname={"Drayage per FCL"} inputname={"indrayage"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"Loading Fee per FCL"} inputname={"unloading"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"Collect Charges"} inputname={"incollectcharges"} inputtype={"currency"} />
            <SPPositionFormGroup labelname={"Outbound others"} inputname={"inboundothers"} inputtype={"currency"} />
            <SPPositionFormGroup readOnly={true} labelname={"Total Inbound"} inputname={"totalinbound"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                // setEditing(true);
                resetInbound();
              }}
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <SPPositionFormGroup labelname={"Inspection Cost"} inputname={"inspectioncost"} inputtype={"currency"} />
        <SPPositionFormGroup labelname={"Legal"} inputname={"legal"} inputtype={"currency"} />
        <SPPositionFormGroup labelname={"Pallets"} inputname={"pallets"} inputtype={"currency"} />
        <SPPositionFormGroup labelname={"Other"} inputname={"other"} inputtype={"currency"} />
        <SPPositionFormGroup
          readOnly={true}
          labelname={"Total Cost"}
          inputname={"totalcost"}
          rowStyle={{ marginTop: "1rem" }}
        />
        <div style={{ marginTop: "1.5rem" }} className='form-group'>
          <label style={{ position: "relative" }}>
            Insurance Cost:{" "}
            <FontAwesomeIcon
              icon={faCalculator}
              onClick={(e) => {
                setShowcalculator("insurance");
              }}
            />
          </label>
          <input
            type='text'
            name='insurancecost'
            readOnly
            value={SPposition.insurancecost || ""}
            onKeyDown={ignoreEnter}
          />
        </div>
        {showcalculator === "insurance" && (
          <div className='SPbottompopupcalculator' style={{ position: "absolute" }}>
            <div className='form-group'>
              <label htmlFor=''>S Incoterms:</label>
              <SearchField
                required={true}
                searchURL='/api/positions/getsincoterms'
                value={SPposition?.sincoterm || ""}
                valueName='sincoterm'
                valueID='sincotermID'
                customplaceholder='S Incoterm'
                onItemSelect={(item) => localHandleInputSelect(item, "sincoterm", "sincoterm")}
                clearfield={clearfield}
              />
            </div>
            <SPPositionFormGroup labelname={"Insurance Rate %"} inputname={"insurancerate"} inputtype={"percent"} />
            <SPPositionFormGroup labelname={"Insurance Factor"} inputname={"insurancefactor"} inputtype={"decimal"} />
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowcalculator("");
              }}
            >
              OK
            </button>
          </div>
        )}
        <SPPositionFormGroup readOnly={true} labelname={"Interest Cost"} inputname={"interestcost"} />
        <SPPositionFormGroup
          readOnly={true}
          labelname={"Purchase Price (inc. I&I)"}
          inputname={"priceafterintins"}
          rowStyle={{ marginTop: "1rem" }}
        />
      </fieldset>
    </>
  );
};

export default PositionsSPFigures;
